<template>
    <div @click="showModal">
      <i class="fa" :class="icon" aria-hidden="true"></i>
    </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      icon: null,
      tableParams: null
    }
  },
  beforeMount() {
    if (this.params.data.comment) {
      this.icon = "fa-pencil-square";
    }
    else {
      this.icon = "fa-pencil-square-o";
    }
  },
  methods: {
    showModal() {
      this.params.showNoteModal(this.params.data);
      this.tableParams = this.params.data;
    },
  },
  watch: {
    tableParams: {
      handler() {
        if (this.tableParams.comment) {
          this.icon = "fa-pencil-square";
        }
        else {
          this.icon = "fa-pencil-square-o";
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
  .fa-pencil-square-o,
  .fa-pencil-square {
    color:#0071EB;
    font-size: 24px;
  }

  .fa-pencil-square-o:hover,
  .fa-pencil-square:hover {
    cursor: pointer;
  }
</style>